import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';
import { CONTROL_BASE } from './Input';
import { useFieldControl } from './Field';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  /** Shows a `usado/limite` counter under the control. Needs `maxLength`. */
  showCount?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, showCount = false, className, id, required, rows = 4, maxLength, value, ...rest },
  ref,
) {
  const field = useFieldControl({
    id,
    required,
    'aria-invalid': invalid ? true : undefined,
    'aria-describedby': rest['aria-describedby'],
  });
  const used = typeof value === 'string' ? value.length : 0;

  return (
    <div className="flex flex-col gap-1">
      <textarea
        ref={ref}
        rows={rows}
        maxLength={maxLength}
        value={value}
        {...rest}
        {...field}
        className={cn(CONTROL_BASE, 'min-h-24 resize-y px-3 py-2 text-base leading-relaxed', className)}
      />
      {showCount && maxLength ? (
        <p className="self-end text-2xs text-text-faint">
          <span className="num">{used}</span>
          {' / '}
          <span className="num">{maxLength}</span>
        </p>
      ) : null}
    </div>
  );
});
